// extracted by mini-css-extract-plugin
export default {"relationType":"RelationTypeCell_relationType__xg3c5"};